
$('#file').on('change', function () {
    $('#import-result').removeClass('alert-success alert-warning alert-danger').addClass('d-none').html('');
});


$('#import-form').on('submit', function (e) {
    e.preventDefault();
    $('#import-result').removeClass('alert-success alert-warning alert-danger').addClass('d-none').html('');

    let fileInput = $('#file')[0].files[0];
    if (!fileInput) {
        alert('Debes seleccionar un archivo Excel antes de importar.');
        return;
    }

    let formData = new FormData();
    formData.append('file', fileInput);

    $.ajax({
        url: $(this).attr('action'),
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function (data) {
            let $result = $('#import-result');
            $result.removeClass('d-none alert-success alert-warning alert-danger');

            if (data.no_actualizados > 0) {
                $result.addClass('alert-warning');
                let html = `
                    <b>${data.actualizados}</b> registros actualizados<br>
                    <b>${data.no_actualizados}</b> no pudieron actualizarse
                `;
                if (data.txt) {
                    html += `<br><a href="${data.txt}" class="btn btn-sm btn-danger mt-2">
                                <i class="fas fa-file-alt"></i> Descargar TXT
                             </a>`;
                }
                $result.html(html);
            } else {
                $result.addClass('alert-success')
                    .html(`<b>${data.actualizados}</b> registros actualizados correctamente.`);
            }
        },
        error: function (xhr) {
            let $result = $('#import-result');
            $result.removeClass('d-none alert-success alert-warning')
                .addClass('alert-danger');

            $result.html('Error al procesar el archivo.');

        }
    });
});
